import React from 'react';

function NoNetwork() {
  return (
    <div
      style={{
        height: '100vh',
        width: '100vw',
        zIndex: 200,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: '#e0e0e0', // light grey
        color: '#333',
          
      }}
    >
        <h1>No Network</h1>
        <p style={{color:'gray',marginTop:'10px'}}> You are not connected to the internet , please check your network connectivity </p>
      </div>
  );
}

export default NoNetwork;
